export default __webpack_public_path__ + "static/media/illustration-algocare-m.f239d008.png";